import { render, staticRenderFns } from "./IconWallet.vue?vue&type=template&id=f171a8a6&scoped=true&"
import script from "./IconWallet.vue?vue&type=script&lang=js&"
export * from "./IconWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f171a8a6",
  null
  
)

export default component.exports